import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import classes from './MultiAssessments.module.css'
import Card from "../../UI/Card"
import CheckedIcon from '../../../assests/lesson/checked.png';
import UnCheckedIcon from '../../../assests/lesson/unchecked.png';
import CloseIcon from '../../../assests/learning-tracking/topic-menu/close-icon2.png';
import LearningAssessmentIcon from '../../../assests/learning-tracking/topic-menu/learning-assessment-icon.png';
import AssessmentIcon from '../../../assests/learning-tracking/topic-menu/assessment-icon.png';
import EditIcon from '../../../assests/learning-tracking/lesson/edit-icon-highlight.png';
import DeleteIcon from '../../../assests/learning-tracking/lesson/delete-icon.png';
import InputText from "../../UI/Inputs/InputText/InputText";
import moment from "moment";
import ContentBankPopup from "../ContentBank/ContentBankPopup";
import { ClassificationEnum } from "../../../models/ClassificationContentBankEnum";
import { assessmentsApi } from "../../../utils";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { SourceTypeTextEnum } from "../../../models/SourceTypeEnum";
import DynamicMessage from "../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../lms-shared/models/DynamicMessageTypeEnum";
import { ActivityTypeEnum, ActivityTypeEnumText } from "../../../models/ActivityTypeEnum";

const MAX_ASSESSMENTS = 7;

const MultiAssessments = ({ data, assessments, setAssessments }) => {

    const texts = useSelector(state => state.translate.texts);

    const [editAssessmentIndex, setEditAssessmentIndex] = useState(null);
    const [showLibraryAssessmentId, setShowLibraryAssessmentId] = useState(null);
    const [showAllAssessments, setShowAllAssessments] = useState(false);
    const [popup, setPopup] = useState(null);

    const dispatch = useDispatch();

    useEffect(() => {
        const getAssessmentsFromApi = async () => {
            const assessmentFilterRange = {
                studyGroupId: data.studyGroupId,
                toCId: data.id,
                sourceType: SourceTypeTextEnum.IDE,
            }
            assessmentsApi.assessmentsFilterRangePost({ assessmentFilterRange }, async (error, resdata, response) => {
                if (error) {
                    console.log(error);
                }
                else {
                    setAssessments([...Array(MAX_ASSESSMENTS).keys()].map(index => {
                        let assessment = { text: index ? `${texts.practiceTask} ${index}` : texts.submissionTask };
                        if (resdata?.assessments?.length) {
                            if (index) {
                                assessment = { ...assessment, ...resdata.assessments.find(a => a.externalId == index) }
                            }
                            else {
                                assessment = { ...assessment, ...resdata.assessments.find(a => ActivityTypeEnum[a.activityType] === ActivityTypeEnum.Final) }
                            }
                        }
                        return assessment;
                    }
                    ));
                }
            })
        }

        if (data.id && !assessments?.length) {
            getAssessmentsFromApi();
        }

    }, [data]);

    const handleError = (userMessage, error, message, response) => {
        dispatch(throwApiError({ userMessage, error, statusCode: response?.statusCode, message: message + error.message, level: 1, component: "MultiAssessments", line: 72 }))
        setPopup(<DynamicMessage type={DynamicMessageTypeEnum.Error} confirmFunc={() => setPopup(false)} content={userMessage} />)
    }

    const deleteAssessment = (index) => {
        assessmentsApi.assessmentsDeleteIdPost(assessments[index].id, (error, resdata, response) => {
            if (error) {
                let userMessage = texts.MessageTitleErrorOccurred;
                if (error.status == 406) {
                    userMessage = texts.errrMsgOnDeleteAssessmentsWithSubmissions;
                }
                handleError(userMessage, error, "assessmentsDeleteIdPost ", response);
            }
            else {
                let newAssessments = [...assessments];
                newAssessments[index].id = null;
                setAssessments(newAssessments);
            }
        })
    }

    const addAssessment = (index) => {
        if (!assessments[index].id) {
            let assessmentAddInput = {
                lessonId: data.id,
                name: assessments[index].text,
                sourceType: SourceTypeTextEnum.IDE,
                activityType: ActivityTypeEnumText.Final,
            }
            if (index) {
                assessmentAddInput.externalId = index.toString();
                assessmentAddInput.activityType = ActivityTypeEnumText.Learning;
            }
            assessmentsApi.assessmentsAddPost({ assessmentAddInput }, (error, resdata, response) => {
                if (error) {
                    handleError(texts.assessmentsAddError, error, "assessmentsAddPost ", response);
                }
                else {
                    let newAssessments = [...assessments];
                    newAssessments[index] = { ...newAssessments[index], ...resdata };
                    setAssessments(newAssessments);
                }
            })
        }
    }

    const changeName = (name, value) => {
        let newAssessments = [...assessments];
        newAssessments[editAssessmentIndex][name] = value;
        setAssessments(newAssessments);
    }

    const updateAssessmentName = () => {
        const assessmentUpdateInput = {
            id: assessments[editAssessmentIndex].id,
            name: assessments[editAssessmentIndex].name,
            contentData: assessments[editAssessmentIndex].contentData
        }
        assessmentsApi.assessmentsUpdatePost({ assessmentUpdateInput }, (error, resdata, response) => {
            setEditAssessmentIndex(null);
            if (error) {
                handleError(texts.assessmentsUpdateError, error, "assessmentsUpdatePost ", response);
            }
        })
    }

    const deleteBaseProject = (index, assessment) => {
        assessmentsApi.assessmentsDeleteBaseProjectIdPost(assessment.id, (error, resdata, response) => {
            if (error) {
                handleError(texts.assessmentsDeleteBaseProjectError, error, "assessmentsDeleteBaseProjectIdPost ", response);
            }
            else {
                let newAssessments = [...assessments];
                newAssessments[index].contentData = resdata;
                newAssessments[index].baseProject = null;
                setAssessments(newAssessments);
            }
        })
    }

    const addBaseProject = (p) => {
        const assessmentAddBaseProjectInput = {
            id: showLibraryAssessmentId,
            baseProjectId: p.id
        }
        assessmentsApi.assessmentsAddBaseProjectPost({ assessmentAddBaseProjectInput }, (error, resdata, response) => {
            setShowLibraryAssessmentId(null)
            if (error) {
                handleError(texts.AssesmentAddBaseProjectError, error, "assessmentsAddBaseProjectPost ", response);
            }
            else {
                let newAssessments = [...assessments];
                const index = newAssessments.findIndex(a => a.id === showLibraryAssessmentId)
                newAssessments[index] = { ...newAssessments[index], ...resdata, baseProject: p };
                setAssessments(newAssessments);
                setShowLibraryAssessmentId(null);
            }
        })
    }

    const closeOnClick = (e) => {
        e.stopPropagation();
        setShowLibraryAssessmentId(null);
    }

    return (
        <div className={classes.MultiAssessments}>
            {popup}
            <h2>{texts.chooseAssessmentsForLesson}</h2>
            <div className={classes.TypesContainer}>
                {assessments.map((assessment, index) =>
                    (showAllAssessments || index < MAX_ASSESSMENTS - 3) && <div key={index} className={classes.CardWarrper}>
                        <div className={classes.CardWarrperTaskHeader}>
                            <img src={assessment.id ? CheckedIcon : UnCheckedIcon} className={classes.CheckedIcon} onClick={() => { assessment.id ? deleteAssessment(index) : addAssessment(index) }} />
                            <img src={index ? LearningAssessmentIcon : AssessmentIcon} />
                            <div className={classes.TaskTexts}>{assessment.text}</div>
                        </div>
                        <div className={`${classes.CardContainer} ${assessment.id ? classes.CardContainerActive : ''}`}>
                            <Card>
                                <div className={classes.CardWarrperTask} onClick={() => addAssessment(index)}>
                                    {assessment.id ?
                                        <>
                                            <div className={classes.EditNameContainer}>
                                                {editAssessmentIndex === index ?
                                                    <InputText
                                                        border={true}
                                                        name={"name"}
                                                        setValue={changeName}
                                                        onBlur={updateAssessmentName}
                                                        value={assessment.name} /> :
                                                    <div className={classes.TaskTexts}>{assessment.name || '?'}</div>}
                                                <img className={classes.EditIcon} src={EditIcon} onClick={() => setEditAssessmentIndex(index)} />
                                            </div>
                                            {assessment.baseProject ?
                                                <div className={classes.AttachBaseProjectContainer}>
                                                    <div className={classes.AttachBaseProjectDetails}>
                                                        <div className={classes.AttachBaseProjectName} onClick={() => setShowLibraryAssessmentId(assessment.id)}>{assessment.baseProject.name}</div>
                                                        <div className={classes.AttachBaseProjectName}>{moment(assessment.baseProject.createdDate).format("HH:mm | DD.M.YYYY")}</div>
                                                    </div>
                                                    <img src={DeleteIcon} onClick={() => deleteBaseProject(index, assessment)} className={classes.DeleteIcon} />
                                                </div> :
                                                <div className={classes.AttachBaseProjectText} onClick={() => setShowLibraryAssessmentId(assessment.id)}>{texts.attachBaseProject}</div>
                                            }
                                        </> :
                                        <div className={classes.TaskTexts}>{assessment.text}</div>}
                                </div>
                            </Card>
                        </div>
                    </div>
                )}
                {assessments?.length ? <img src={CloseIcon} className={`${classes.OpenIcon} ${showAllAssessments ? classes.CloseIcon : ''}`} onClick={() => setShowAllAssessments(!showAllAssessments)} /> : ''}
            </div>
            {showLibraryAssessmentId !== null ? <ContentBankPopup type={ClassificationEnum.project} selectOnClick={addBaseProject} closeOnClick={closeOnClick} /> : ''}
        </div>
    )
}

export default MultiAssessments;